import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=66412544&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66412544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66412544')) {
      api.createRecord('66412544', component.options)
    } else {
      api.reload('66412544', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=66412544&scoped=true", function () {
      api.rerender('66412544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentCallback/Index.vue"
export default component.exports